"use client";

import CountryContactPage from "@/components/Contact/CountryContactPage";

export default function Thailand() {
  return <CountryContactPage headquarters="th" />;
}
